const LessonType = {
  FREE_PLUS_LESSON: 3,
  PAID_PLUS_LESSON: 4,
  COMPREHENSIVE_LESSON: 5,
  REVIEW_LESSON: 6
};

export default LessonType;
